import React, { useMemo, useContext } from "react";
import { string, number, bool } from "prop-types";
import useSearchValues from "../../../../common/useSearchValues.js";
import { QueryStringContext } from "../../QueryStringContext/QueryStringContext.jsx";

const propTypes = {
  totalResults: number.isRequired,
  isLoading: bool,
};

const ResultsInfo = ({ perPage, totalResults, isLoading }) => {
  const { searchValues } = useSearchValues();
  const { model } = useContext(QueryStringContext);

  const { dictionary } = model;
  const page = Number(searchValues.page);
  //expect piped string
  const infoLabelArray = dictionary.resultsInfoLabel.split("|");
  const currentResultsRange = useMemo(() => {
    //ensure base 10 number
    const currentPageNumber = page + 1 || 1;

    // if results are only one page, eschew the range entirely
    if (!perPage || totalResults <= perPage) {
      return `${totalResults}`;
    }

    // Upper bound of visible results
    let ceiling = currentPageNumber * perPage;

    // Lower bound of visible results
    let floor = ceiling - perPage + 1;

    // make sure the ceiling does not exceed total results
    if (ceiling > totalResults) {
      ceiling = totalResults;
    }

    // otherwise, return the full range
    return ` ${floor}–${ceiling}`;
  }, [page, perPage, totalResults]);

  return Number(totalResults) > 0 ? (
    <div
      role="alert"
      aria-live="polite"
      className="results-info"
      aria-busy={isLoading}
    >
      {currentResultsRange || "0 - 0"}
      {totalResults > 0 && (
        <>
          {" "}
          {infoLabelArray?.[1] || "of"} {totalResults}{" "}
          {infoLabelArray?.[2] || ""}
        </>
      )}
      {searchValues.keyword && (
        <>
          {" "}
          for &ldquo;{searchValues.keyword}&rdquo;
        </>
      )}
    </div>
  ) : null;
};

ResultsInfo.propTypes = propTypes;
export default ResultsInfo;
